module.exports = __webpack_public_path__ + "img/continue-button-old.ffca2ac3.png";